/*! Agile Pixel https://agilepixel.io - 2021*/
import gsap from 'gsap';

export default {
  init(selector) {
    const imageLoading = gsap.timeline();
    const cover = selector.querySelector('.js-cover');
    const image = selector.querySelector('.js-image');
    imageLoading
      .to(cover, {
        opacity: 1,
        width: '100%',
        duration: 0.8,
      })
      .to(cover, {
        x: '100%',
        duration: 0.8,
      })
      .to(
        image,
        {
          opacity: 1,
          duration: 0.5,
        },
        '-=.8'
      );
  },
};

//Animate logo in Hero
